import { render, staticRenderFns } from "./InputInformasiUmum.vue?vue&type=template&id=4354e4b5&scoped=true&"
import script from "./InputInformasiUmum.vue?vue&type=script&lang=js&"
export * from "./InputInformasiUmum.vue?vue&type=script&lang=js&"
import style0 from "./InputInformasiUmum.vue?vue&type=style&index=0&id=4354e4b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4354e4b5",
  null
  
)

export default component.exports